import { useEffect, useState } from 'react';
import { color as themeColor } from '../../../app/theme';

const IconWaList = ({
  className,
  id,
  color = themeColor.$10,
  hoverColor = themeColor.$7,
}) => {
  const [mainColor, setMainColor] = useState(color);

  useEffect(() => {
    if (color !== mainColor) {
      setMainColor(color);
    }
  }, [color]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="24"
      height="24"
      className={className}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id={id}
          d="M17 4a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h10zm1.4 11.8H5.599L5.6 18A1.4 1.4 0 0 0 7 19.4h10a1.4 1.4 0 0 0 1.4-1.4v-2.2zm0-5H5.599v3.399H18.4V10.8zM17 5.6H7A1.4 1.4 0 0 0 5.6 7l-.001 2.199H18.4V7A1.4 1.4 0 0 0 17 5.6z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={`IconWaList${id}`} fill="#fff">
          <use xlinkHref={`#${id}`} />
        </mask>
        <g fill={mainColor} mask={`url(#IconWaList${id})`}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
};

export default IconWaList;
